import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, CircularProgress, Avatar, IconButton, Grid, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../../services/api';
function SponsorsTab() {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [name, setName] = useState('');
  const [logo, setLogo] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const fetchSponsors = () => {
    setLoading(true);
    setError(null);
    api.get('/api/sponsors')
      .then(({ data }) => setSponsors(Array.isArray(data) ? data : []))
      .catch(() => setError('Failed to load sponsors'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchSponsors(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!name || !logo) return;
    setSubmitting(true);
    try {
      const res = await api.post('/api/sponsors', { name, logo });
      if (!res || res.status >= 400) throw new Error('Failed to add sponsor');
      setName('');
      setLogo('');
      fetchSponsors();
    } catch {
      setError('Failed to add sponsor');
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this sponsor?')) return;
    setSubmitting(true);
    try {
      await api.delete(`/api/sponsors/${id}`);
      fetchSponsors();
    } catch {
      setError('Failed to delete sponsor');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', mt: 4, p: 2 }}>
      <Typography variant="h5" fontWeight="bold" color="primary" sx={{ mb: 2 }}>Sponsors Logo Management</Typography>
      <Paper sx={{ p: 2, mb: 3 }}>
        <form onSubmit={handleAdd} style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <TextField label="Sponsor Name" value={name} onChange={e => setName(e.target.value)} size="small" required sx={{ minWidth: 180 }} />
          <TextField label="Logo URL" value={logo} onChange={e => setLogo(e.target.value)} size="small" required sx={{ minWidth: 220 }} />
          <Button type="submit" variant="contained" color="primary" disabled={submitting || !name || !logo}>Add Sponsor</Button>
        </form>
      </Paper>
      {loading ? <CircularProgress /> : error ? <Typography color="error">{error}</Typography> : (
        <Grid container spacing={2}>
          {sponsors.map(s => (
            <Grid item xs={6} sm={4} md={3} key={s._id}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                <Avatar src={s.logo} alt={s.name} sx={{ width: 56, height: 56, mb: 1 }} />
                <Typography variant="subtitle2" sx={{ fontWeight: 700, textAlign: 'center' }}>{s.name}</Typography>
                <IconButton color="error" onClick={() => handleDelete(s._id)} size="small"><DeleteIcon /></IconButton>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}

export default SponsorsTab;
